import clsx from "clsx"
import Image from "next/image"
import React from "react"

import BioModalTrigger from "./leadership/BioModalTrigger"

interface BioModalCardProps {
  name: string
  title: string
  company?: string
  bio?: string
  imgUrl?: string
  linkedIn?: string
  lightmode?: boolean
  gridStyle?: 4 | 6
}

const BioModalCard: React.FC<BioModalCardProps> = ({
  name,
  title,
  company,
  bio,
  imgUrl,
  linkedIn,
  lightmode = false,
  gridStyle = 4,
}) => (
  <div
    className={clsx(
      "flex flex-col mt-2 space-y-2 transition-all duration-300 ease-in-out col-span-full hover:mt-0 hover:mb-2 hover:opacity-80 md:col-span-2",
      gridStyle === 4 ? "lg:col-span-4" : "lg:col-span-6",
    )}
  >
    <BioModalTrigger
      modalOpen
      name={name}
      title={title}
      bio={bio}
      linkedin={linkedIn}
      lightmode={lightmode}
      company={company}
    >
      <Image
        src={imgUrl}
        height={gridStyle === 4 ? 264 : 390}
        width={gridStyle === 4 ? 352 : 552}
        alt={name}
        className="rounded-lg w-full"
      />
      <div
        className={clsx(
          "flex flex-col p-4 hover:cursor-pointer",
          lightmode ? "text-gray-90" : "text-gray-2.5",
        )}
      >
        <h3 className="mb-2 heading2 lg:heading1">{name}</h3>
        <h5 className="mb-1 body3">{title}</h5>
        {company && <h5 className="body3">{company}</h5>}
      </div>
    </BioModalTrigger>
  </div>
)

export default BioModalCard
